const PageState = Object.freeze({ loading: 1, loaded: 2, error: 3 });

export default PageState;
